import axios from 'axios';

const baseURL = process.env.QUICK_LINKS_API_URL;
const appAPIURL = process.env.CONTENT_ENGINE_URL;

const health = {

    // GET API Version
    async getApiVersion() {
        return axios.get(`${baseURL}/health`);
    },

    async getContenEngineVersion() {
        return axios.get(`${appAPIURL}/health/healthy`);
    }
};

export default health;



// WEBPACK FOOTER //
// ./src/api/health.js